export const CREATE_CARB_CYCLING_PLAN = 'carbCyling/CREATE_CARB_CYCLING_PLAN';
export const CREATE_CARB_CYCLING_PLAN_SUCCESS = 'carbCyling/CREATE_CARB_CYCLING_PLAN_SUCCESS';
export const CREATE_CARB_CYCLING_PLAN_ERROR = 'carbCyling/CREATE_CARB_CYCLING_PLAN_ERROR';

export const GET_CARB_CYCLING_PLAN = 'carbCyling/GET_CARB_CYCLING_PLAN';
export const GET_CARB_CYCLING_PLAN_SUCCESS = 'carbCyling/GET_CARB_CYCLING_PLAN_SUCCESS';
export const GET_CARB_CYCLING_PLAN_ERROR = 'carbCyling/GET_CARB_CYCLING_PLAN_ERROR';

export const HANDLE_CARB_CLYCLING_MODAL_OPEN = 'carbCycling/HANDLE_CARB_CLYCLING_MODAL_OPEN';
export const HANDLE_IS_CARB_CYCLING_PLAN_CREATED = 'carbCycling/HANDLE_IS_CARB_CYCLING_PLAN_CREATED';